import React, { useState, useEffect } from "react";
import styled, { keyframes } from "styled-components";
import { requestWithdrawal } from "./client";
import {
  getWithdrawalEligibility,
  createPayoutRequest,
} from "./accountClient";
import { useI18n } from "./i18n";

/* ═══════════════════════════════════════════════════════════════════════════
   I18N — Local translation table (fr, en, es, de, pt, ar)
═══════════════════════════════════════════════════════════════════════════ */
const WT = {
  // Header
  "title":          { fr:"Retirer",                en:"Withdraw",                es:"Retirar",                  de:"Abheben",                  pt:"Sacar",                    ar:"سحب"                  },
title2: {
  fr: "Ma récompense",
  en: "My reward",
  es: "Mi recompensa",
  de: "Meine Belohnung",
  pt: "Minha recompensa",
  ar: "مكافأتي",
},
"reward.desc": {
  fr: "Les 100 EVP de démarrage servent uniquement à trader — ils ne génèrent aucune récompense par eux-mêmes. Seuls les EVP gagnés AU-DESSUS de ce socle de 100, via des trades gagnants, sont convertibles en récompense réelle.",
  en: "The 100 starter EVP are only meant for trading — they generate no reward on their own. Only EVP won ABOVE that base of 100, through winning trades, convert into a real reward.",
  es: "Los 100 EVP iniciales sirven solo para operar — no generan ninguna recompensa por sí mismos. Solo los EVP ganados POR ENCIMA de esa base de 100, mediante operaciones ganadoras, se convierten en recompensa real.",
  de: "Die 100 Start-EVP dienen nur zum Handeln — sie generieren allein keine Prämie. Nur EVP, die ÜBER dieser Basis von 100 durch gewinnbringende Trades gewonnen werden, wandeln sich in eine echte Prämie um.",
  pt: "Os 100 EVP iniciais servem apenas para negociar — não geram nenhuma recompensa por si só. Somente os EVP ganhos ACIMA dessa base de 100, por meio de negociações vencedoras, se convertem em recompensa real.",
  ar: "تُستخدم الـ100 EVP الأولية للتداول فقط — ولا تولّد أي مكافأة بحد ذاتها. فقط EVP المكتسبة فوق هذا الأساس البالغ 100، عبر صفقات رابحة، تتحول إلى مكافأة حقيقية.",
},  "sub":            { fr:"Choisissez votre méthode de retrait.", en:"Choose your withdrawal method.", es:"Elige tu método de retiro.", de:"Wählen Sie Ihre Auszahlungsmethode.", pt:"Escolha seu método de saque.", ar:"اختر طريقة السحب." },
  "bal":            { fr:"Solde disponible",       en:"Available balance",       es:"Saldo disponible",         de:"Verfügbares Guthaben",     pt:"Saldo disponível",         ar:"الرصيد المتاح"        },

  // Method tabs
  "tab.crypto":     { fr:"Crypto",                 en:"Crypto",                  es:"Cripto",                   de:"Krypto",                   pt:"Cripto",                   ar:"كريبتو"               },
  "tab.mobile":     { fr:"Mobile",                 en:"Mobile",                  es:"Móvil",                    de:"Mobil",                    pt:"Móvel",                    ar:"موبايل"               },
  "tab.bank":       { fr:"Virement",               en:"Wire",                    es:"Transferencia",            de:"Überweisung",              pt:"Transferência",            ar:"تحويل"                },
  "tab.paypal":     { fr:"PayPal",                 en:"PayPal",                  es:"PayPal",                   de:"PayPal",                   pt:"PayPal",                   ar:"PayPal"               },

  // Field labels
  "lbl.receive":    { fr:"Recevoir en",            en:"Receive in",              es:"Recibir en",               de:"Empfangen in",             pt:"Receber em",               ar:"الاستلام بـ"          },
  "lbl.amount":     { fr:"Montant",                en:"Amount",                  es:"Monto",                    de:"Betrag",                   pt:"Valor",                    ar:"المبلغ"               },
  "lbl.amount_w":   { fr:"Montant à retirer",      en:"Amount to withdraw",      es:"Monto a retirar",          de:"Auszahlungsbetrag",        pt:"Valor a sacar",            ar:"المبلغ المطلوب سحبه"  },
  "lbl.address":    { fr:"Adresse de destination", en:"Destination address",     es:"Dirección de destino",     de:"Zieladresse",              pt:"Endereço de destino",      ar:"عنوان الوجهة"         },
  "lbl.phone":      { fr:"Numéro Mobile Money",    en:"Mobile Money number",     es:"Número Mobile Money",      de:"Mobile-Money-Nummer",      pt:"Número Mobile Money",      ar:"رقم Mobile Money"     },
  "lbl.bank":       { fr:"Coordonnées bancaires de destination", en:"Bank details", es:"Datos bancarios de destino", de:"Bankverbindung", pt:"Dados bancários de destino", ar:"التفاصيل المصرفية" },
  "lbl.holder":     { fr:"Titulaire du compte",    en:"Account holder",          es:"Titular de la cuenta",     de:"Kontoinhaber",             pt:"Titular da conta",         ar:"صاحب الحساب"          },
  "lbl.iban":       { fr:"IBAN",                   en:"IBAN",                    es:"IBAN",                     de:"IBAN",                     pt:"IBAN",                     ar:"IBAN"                 },
  "lbl.bic":        { fr:"BIC / SWIFT",            en:"BIC / SWIFT",             es:"BIC / SWIFT",              de:"BIC / SWIFT",              pt:"BIC / SWIFT",              ar:"BIC / SWIFT"          },
  "lbl.country":    { fr:"Pays",                   en:"Country",                 es:"País",                     de:"Land",                     pt:"País",                     ar:"البلد"                },
  "lbl.operators":  { fr:"Opérateurs disponibles", en:"Available operators",     es:"Operadores disponibles",   de:"Verfügbare Anbieter",      pt:"Operadoras disponíveis",   ar:"المشغلون المتاحون"    },
  "lbl.operator":   { fr:"Opérateur Mobile Money", en:"Mobile Money operator",   es:"Operador Mobile Money",    de:"Mobile-Money-Anbieter",    pt:"Operadora Mobile Money",   ar:"مشغل Mobile Money"    },
  "lbl.email_pp":   { fr:"Email PayPal",           en:"PayPal email",            es:"Email de PayPal",          de:"PayPal-E-Mail",            pt:"E-mail PayPal",            ar:"بريد PayPal الإلكتروني" },
  "operators":      { fr:"opérateurs",             en:"operators",               es:"operadores",               de:"Anbieter",                 pt:"operadoras",               ar:"مشغلون"               },
  "operator":       { fr:"opérateur",              en:"operator",                es:"operador",                 de:"Anbieter",                 pt:"operadora",                ar:"مشغل"                 },

  // Placeholders
  "ph.amount":      { fr:"0.00",                   en:"0.00",                    es:"0.00",                     de:"0,00",                     pt:"0,00",                     ar:"0.00"                 },
  "ph.phone":       { fr:"6X XX XX XX XX",         en:"6X XX XX XX XX",          es:"6X XX XX XX XX",           de:"6X XX XX XX XX",           pt:"6X XX XX XX XX",           ar:"6X XX XX XX XX"       },
  "ph.holder":      { fr:"Nom complet du titulaire", en:"Full account holder name", es:"Nombre completo del titular", de:"Vollständiger Kontoinhabername", pt:"Nome completo do titular", ar:"الاسم الكامل لصاحب الحساب" },
  "ph.email":       { fr:"vous@example.com",       en:"you@example.com",         es:"tu@ejemplo.com",           de:"sie@beispiel.de",          pt:"voce@exemplo.com",         ar:"you@example.com"      },
  "all":            { fr:"Tous",                   en:"All",                     es:"Todos",                    de:"Alle",                     pt:"Todos",                    ar:"الكل"                 },

  // Hints
  "hint.insufficient":{ fr:"Solde insuffisant",      en:"Insufficient balance",     es:"Saldo insuficiente",       de:"Unzureichendes Guthaben",  pt:"Saldo insuficiente",       ar:"رصيد غير كافٍ"        },
  "hint.min_crypto":{ fr:"Minimum : $5 EVP",         en:"Minimum: $5 EVP",          es:"Mínimo: $5 EVP",           de:"Minimum: $5 EVP",          pt:"Mínimo: $5 EVP",           ar:"الحد الأدنى: 5$ EVP"  },
  "hint.min":       { fr:"Minimum : {min} USD",      en:"Minimum: {min} USD",       es:"Mínimo: {min} USD",        de:"Minimum: {min} USD",       pt:"Mínimo: {min} USD",        ar:"الحد الأدنى: {min}$"  },
  "hint.address":   { fr:"Vérifiez que cette adresse {coin} est correcte et sur le bon réseau.",
                      en:"Make sure this {coin} address is correct and on the right network.",
                      es:"Verifica que esta dirección {coin} sea correcta y esté en la red adecuada.",
                      de:"Stellen Sie sicher, dass diese {coin}-Adresse korrekt und im richtigen Netzwerk ist.",
                      pt:"Verifique se este endereço {coin} está correto e na rede certa.",
                      ar:"تأكد من صحة عنوان {coin} وأنه على الشبكة الصحيحة." },
  "hint.evp_eq":    { fr:"= {evp} EVP seront débités de votre solde", en:"= {evp} EVP will be debited from your balance",
                      es:"= {evp} EVP se debitarán de tu saldo",     de:"= {evp} EVP werden von Ihrem Guthaben abgezogen",
                      pt:"= {evp} EVP serão debitados do seu saldo", ar:"= سيتم خصم {evp} EVP من رصيدك" },
  "hint.paypal":    { fr:"Assurez-vous que cet email est associé à un compte PayPal vérifié.",
                      en:"Make sure this email is linked to a verified PayPal account.",
                      es:"Asegúrate de que este email esté vinculado a una cuenta PayPal verificada.",
                      de:"Stellen Sie sicher, dass diese E-Mail mit einem verifizierten PayPal-Konto verknüpft ist.",
                      pt:"Certifique-se de que este e-mail está vinculado a uma conta PayPal verificada.",
                      ar:"تأكد من ربط هذا البريد الإلكتروني بحساب PayPal موثق." },

  // Summary
  "sum.send":       { fr:"Vous envoyez",           en:"You send",                es:"Envías",                   de:"Sie senden",               pt:"Você envia",               ar:"ترسل"                 },
  "sum.withdraw":   { fr:"Vous retirez",           en:"You withdraw",            es:"Retiras",                  de:"Sie heben ab",             pt:"Você saca",                ar:"تسحب"                 },
  "sum.fee_plat":   { fr:"Frais plateforme (0.1%)",en:"Platform fee (0.1%)",     es:"Comisión plataforma (0.1%)",de:"Plattformgebühr (0.1%)",  pt:"Taxa da plataforma (0,1%)",ar:"رسوم المنصة (0.1%)"   },
  "sum.fee_net":    { fr:"Frais réseau",           en:"Network fee",             es:"Comisión de red",          de:"Netzwerkgebühr",           pt:"Taxa de rede",             ar:"رسوم الشبكة"          },
  "sum.fee_payout": { fr:"Frais de paiement",      en:"Payout fee",              es:"Comisión de pago",         de:"Auszahlungsgebühr",        pt:"Taxa de pagamento",        ar:"رسوم الدفع"           },
  "sum.delay":      { fr:"Délai de traitement",    en:"Processing time",         es:"Tiempo de procesamiento",  de:"Bearbeitungszeit",         pt:"Tempo de processamento",   ar:"وقت المعالجة"         },
  "sum.delay_mob":  { fr:"24–48h après validation",en:"24–48h after validation", es:"24–48h tras validación",   de:"24–48 St. nach Validierung",pt:"24–48h após validação",   ar:"24–48 ساعة بعد التحقق" },
  "sum.delay_bank": { fr:"1–3 jours ouvrés",       en:"1–3 business days",       es:"1–3 días hábiles",         de:"1–3 Werktage",             pt:"1–3 dias úteis",           ar:"1–3 أيام عمل"        },
  "sum.delay_pp":   { fr:"24h après validation",   en:"24h after validation",    es:"24h tras validación",      de:"24 St. nach Validierung",  pt:"24h após validação",       ar:"24 ساعة بعد التحقق"   },
  "sum.receive":    { fr:"Vous recevez (~)",       en:"You receive (~)",         es:"Recibes (~)",              de:"Sie erhalten (~)",         pt:"Você recebe (~)",          ar:"تستلم (~)"            },
  "sum.receive_e":  { fr:"Vous recevez",           en:"You receive",             es:"Recibes",                  de:"Sie erhalten",             pt:"Você recebe",              ar:"تستلم"                },
  "sum.free":       { fr:"Gratuit",                en:"Free",                    es:"Gratis",                   de:"Kostenlos",                pt:"Grátis",                   ar:"مجاني"                },
  "sum.included":   { fr:"Inclus",                 en:"Included",                es:"Incluido",                 de:"Inklusive",                pt:"Incluído",                 ar:"شامل"                 },

  // Eligibility
  "elig.loading":   { fr:"Vérification de l'éligibilité…", en:"Checking eligibility…", es:"Verificando elegibilidad…", de:"Berechtigung wird geprüft…", pt:"Verificando elegibilidade…", ar:"جاري التحقق من الأهلية…" },
  "elig.err":       { fr:"Impossible de charger les conditions d'éligibilité.", en:"Could not load eligibility conditions.", es:"No se pudieron cargar las condiciones de elegibilidad.", de:"Berechtigungsbedingungen konnten nicht geladen werden.", pt:"Não foi possível carregar as condições de elegibilidade.", ar:"تعذّر تحميل شروط الأهلية." },
  "elig.ok":        { fr:"Éligible au retrait",    en:"Eligible to withdraw",    es:"Elegible para retirar",    de:"Berechtigt zur Auszahlung",pt:"Elegível para sacar",      ar:"مؤهل للسحب"           },
  "elig.rate":      { fr:"100 EVP = 1 USD",        en:"100 EVP = 1 USD",         es:"100 EVP = 1 USD",          de:"100 EVP = 1 USD",          pt:"100 EVP = 1 USD",          ar:"100 EVP = 1$"         },
  "elig.withdrawable":{ fr:"Montant retirable",    en:"Withdrawable amount",     es:"Monto retirable",          de:"Auszahlbarer Betrag",      pt:"Valor sacável",            ar:"المبلغ القابل للسحب"  },
  "elig.notok":     { fr:"COMPTE NON ÉLIGIBLE",    en:"ACCOUNT NOT ELIGIBLE",    es:"CUENTA NO ELEGIBLE",       de:"KONTO NICHT BERECHTIGT",   pt:"CONTA NÃO ELEGÍVEL",       ar:"الحساب غير مؤهل"      },
  "elig.trades":    { fr:"Trades",                 en:"Trades",                  es:"Trades",                   de:"Trades",                   pt:"Trades",                   ar:"الصفقات"              },
  "elig.days":      { fr:"Jours actifs",           en:"Active days",             es:"Días activos",             de:"Aktive Tage",              pt:"Dias ativos",              ar:"أيام النشاط"          },
  "elig.market":    { fr:"Max/marché",             en:"Max/market",              es:"Máx/mercado",              de:"Max/Markt",                pt:"Máx/mercado",              ar:"الحد الأقصى/سوق"      },
  "elig.retirable": { fr:"Retirable",              en:"Withdrawable",            es:"Retirable",                de:"Auszahlbar",               pt:"Sacável",                  ar:"قابل للسحب"           },

  // Status info banners
  "info.crypto":    { fr:"Toutes les demandes sont vérifiées manuellement. Traitement sous", en:"All requests are manually reviewed. Processed within", es:"Todas las solicitudes se revisan manualmente. Procesadas en", de:"Alle Anfragen werden manuell geprüft. Bearbeitung innerhalb von", pt:"Todas as solicitações são revisadas manualmente. Processadas em", ar:"تتم مراجعة جميع الطلبات يدويًا. تتم المعالجة خلال" },
  "info.mobile":    { fr:"Les paiements Mobile Money sont effectués manuellement sous 24–48h après validation par notre équipe.", en:"Mobile Money payouts are processed manually within 24–48h after our team validates the request.", es:"Los pagos Mobile Money se procesan manualmente en 24–48h tras la validación de nuestro equipo.", de:"Mobile-Money-Auszahlungen werden nach Validierung durch unser Team innerhalb von 24–48 Std. manuell durchgeführt.", pt:"Os pagamentos Mobile Money são processados manualmente em 24–48h após validação da nossa equipe.", ar:"تتم معالجة مدفوعات Mobile Money يدويًا خلال 24–48 ساعة بعد التحقق من قبل فريقنا." },
  "info.bank":      { fr:"Le virement sera émis vers votre IBAN après vérification manuelle sous 1–3 jours ouvrés. Vous recevrez un email de confirmation.", en:"The wire will be sent to your IBAN after manual verification within 1–3 business days. You will receive a confirmation email.", es:"La transferencia se enviará a tu IBAN tras verificación manual en 1–3 días hábiles. Recibirás un correo de confirmación.", de:"Die Überweisung erfolgt nach manueller Prüfung innerhalb von 1–3 Werktagen. Sie erhalten eine Bestätigungs-E-Mail.", pt:"A transferência será enviada para seu IBAN após verificação manual em 1–3 dias úteis. Você receberá um e-mail de confirmação.", ar:"سيتم إرسال التحويل إلى IBAN الخاص بك بعد التحقق اليدوي خلال 1–3 أيام عمل. ستتلقى رسالة بريد إلكتروني للتأكيد." },
  "info.paypal":    { fr:"Le paiement PayPal sera envoyé sous 24h après validation manuelle par notre équipe. Vous recevrez un email de confirmation.", en:"The PayPal payment will be sent within 24h after manual validation by our team. You will receive a confirmation email.", es:"El pago PayPal se enviará en 24h tras validación manual de nuestro equipo. Recibirás un correo de confirmación.", de:"Die PayPal-Zahlung wird innerhalb von 24 Std. nach manueller Validierung durch unser Team gesendet. Sie erhalten eine Bestätigungs-E-Mail.", pt:"O pagamento PayPal será enviado em 24h após validação manual da nossa equipe. Você receberá um e-mail de confirmação.", ar:"سيتم إرسال دفعة PayPal خلال 24 ساعة بعد التحقق اليدوي من قبل فريقنا. ستتلقى رسالة بريد إلكتروني للتأكيد." },

  // Submit buttons
  "btn.sending":    { fr:"Envoi…",                 en:"Sending…",                es:"Enviando…",                de:"Senden…",                  pt:"Enviando…",                ar:"جاري الإرسال…"        },
  "btn.sending_l":  { fr:"Envoi de la demande…",   en:"Sending request…",        es:"Enviando solicitud…",      de:"Anfrage wird gesendet…",   pt:"Enviando solicitação…",    ar:"جاري إرسال الطلب…"    },
  "btn.withdraw":   { fr:"Retirer",                en:"Withdraw",                es:"Retirar",                  de:"Abheben",                  pt:"Sacar",                    ar:"سحب"                  },
  "btn.via_mob":    { fr:"Retirer via Mobile Money — {country}", en:"Withdraw via Mobile Money — {country}", es:"Retirar vía Mobile Money — {country}", de:"Auszahlung via Mobile Money — {country}", pt:"Sacar via Mobile Money — {country}", ar:"السحب عبر Mobile Money — {country}" },
  "btn.select_c":   { fr:"Sélectionnez votre pays",en:"Select your country",     es:"Selecciona tu país",       de:"Wählen Sie Ihr Land",      pt:"Selecione seu país",       ar:"اختر بلدك"            },
  "btn.bank":       { fr:"Retrait bancaire",       en:"Bank withdrawal",         es:"Retiro bancario",          de:"Bank-Auszahlung",          pt:"Saque bancário",           ar:"السحب البنكي"         },
  "btn.paypal":     { fr:"Retirer via PayPal",     en:"Withdraw via PayPal",     es:"Retirar vía PayPal",       de:"Auszahlung via PayPal",    pt:"Sacar via PayPal",         ar:"السحب عبر PayPal"     },

  // Success
  "succ.title_c":   { fr:"Retrait Crypto Demandé",         en:"Crypto Withdrawal Requested", es:"Retiro Cripto Solicitado",  de:"Krypto-Auszahlung beantragt", pt:"Saque Cripto Solicitado", ar:"تم طلب سحب كريبتو" },
  "succ.title_m":   { fr:"Retrait Mobile Enregistré",       en:"Mobile Withdrawal Registered",es:"Retiro Móvil Registrado",   de:"Mobile-Auszahlung registriert",pt:"Saque Móvel Registrado",  ar:"تم تسجيل السحب عبر الموبايل" },
  "succ.title_b":   { fr:"Retrait Bancaire Enregistré",     en:"Bank Withdrawal Registered",  es:"Retiro Bancario Registrado",de:"Banküberweisung registriert", pt:"Saque Bancário Registrado",ar:"تم تسجيل السحب البنكي" },
  "succ.title_p":   { fr:"Retrait PayPal Enregistré",       en:"PayPal Withdrawal Registered",es:"Retiro PayPal Registrado",  de:"PayPal-Auszahlung registriert",pt:"Saque PayPal Registrado",  ar:"تم تسجيل السحب عبر PayPal" },
  "succ.msg_c":     { fr:"Votre demande de ${amount} {coin} est en cours d'examen. Les fonds seront envoyés sous 24h.",
                      en:"Your request of ${amount} {coin} is under review. Funds will be sent within 24 hours.",
                      es:"Tu solicitud de ${amount} {coin} está en revisión. Los fondos se enviarán en 24 horas.",
                      de:"Ihre Anfrage über ${amount} {coin} wird geprüft. Die Mittel werden innerhalb von 24 Std. gesendet.",
                      pt:"Sua solicitação de ${amount} {coin} está em análise. Os fundos serão enviados em 24 horas.",
                      ar:"طلبك بمبلغ ${amount} {coin} قيد المراجعة. سيتم إرسال الأموال خلال 24 ساعة." },
  "succ.msg_m":     { fr:"Votre retrait de ${amount} USD vers {dial} {phone} sera traité manuellement sous 24–48h.",
                      en:"Your ${amount} USD withdrawal to {dial} {phone} will be processed manually within 24–48h.",
                      es:"Tu retiro de ${amount} USD a {dial} {phone} se procesará manualmente en 24–48h.",
                      de:"Ihre Auszahlung von ${amount} USD an {dial} {phone} wird innerhalb von 24–48 Std. manuell bearbeitet.",
                      pt:"Seu saque de ${amount} USD para {dial} {phone} será processado manualmente em 24–48h.",
                      ar:"سيتم معالجة سحبك بمبلغ ${amount} USD إلى {dial} {phone} يدويًا خلال 24–48 ساعة." },
  "succ.msg_b":     { fr:"Votre virement de ${amount} USD vers votre IBAN sera traité sous 1–3 jours ouvrés.",
                      en:"Your ${amount} USD wire to your IBAN will be processed within 1–3 business days.",
                      es:"Tu transferencia de ${amount} USD a tu IBAN se procesará en 1–3 días hábiles.",
                      de:"Ihre Überweisung von ${amount} USD an Ihr IBAN wird innerhalb von 1–3 Werktagen bearbeitet.",
                      pt:"Sua transferência de ${amount} USD para seu IBAN será processada em 1–3 dias úteis.",
                      ar:"سيتم معالجة تحويلك بمبلغ ${amount} USD إلى IBAN الخاص بك خلال 1–3 أيام عمل." },
  "succ.msg_p":     { fr:"Votre paiement PayPal de ${amount} USD vers {email} sera envoyé sous 24h.",
                      en:"Your ${amount} USD PayPal payment to {email} will be sent within 24h.",
                      es:"Tu pago PayPal de ${amount} USD a {email} se enviará en 24h.",
                      de:"Ihre PayPal-Zahlung von ${amount} USD an {email} wird innerhalb von 24 Std. gesendet.",
                      pt:"Seu pagamento PayPal de ${amount} USD para {email} será enviado em 24h.",
                      ar:"سيتم إرسال دفعتك عبر PayPal بمبلغ ${amount} USD إلى {email} خلال 24 ساعة." },
  "succ.ref":       { fr:"Référence",              en:"Reference",               es:"Referencia",               de:"Referenz",                 pt:"Referência",               ar:"المرجع"               },
  "btn.close":      { fr:"Fermer",                 en:"Close",                   es:"Cerrar",                   de:"Schließen",                pt:"Fechar",                   ar:"إغلاق"                },

  // Misc
  "delay_crypto":   { fr:"1–24h",                  en:"1–24h",                   es:"1–24h",                    de:"1–24 Std.",                pt:"1–24h",                    ar:"1–24 ساعة"            },
};

function wt(key, lang, vars = {}) {
  const v = WT[key]?.[lang] ?? WT[key]?.fr ?? key;
  return Object.entries(vars).reduce((acc, [k, val]) => acc.replaceAll(`{${k}}`, val), v);
}

/* ═══════════════════════════════════════════════════════════════════════════
   Animations & data
═══════════════════════════════════════════════════════════════════════════ */
const fadeIn  = keyframes`from{opacity:0}to{opacity:1}`;
const slideUp = keyframes`from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}`;
const checkIn = keyframes`
  0%{transform:scale(0) rotate(-45deg);opacity:0}
  60%{transform:scale(1.2) rotate(5deg);opacity:1}
  100%{transform:scale(1) rotate(0deg);opacity:1}
`;

const FEE_RATE = 0.001;

const COINS = [
  { id:"EVP",  icon:"💎", label:"EVP",  fee:0     },
  { id:"USDC", icon:"$",  label:"USDC", fee:1     },
  { id:"USDT", icon:"₮",  label:"USDT", fee:1     },
  { id:"BTC",  icon:"₿",  label:"BTC",  fee:0.0001},
];

const TINGG_COUNTRIES = [
  { code:"CI", flag:"🇨🇮", name:"Côte d'Ivoire", currency:"XOF", operators:["Orange Money","MTN MoMo","Wave","Moov Money"] },
  { code:"SN", flag:"🇸🇳", name:"Sénégal",       currency:"XOF", operators:["Orange Money","Wave","Free Money"] },
  { code:"CM", flag:"🇨🇲", name:"Cameroun",      currency:"XAF", operators:["MTN MoMo","Orange Money"] },
  { code:"GH", flag:"🇬🇭", name:"Ghana",         currency:"GHS", operators:["MTN MoMo","Vodafone Cash","AirtelTigo Money"] },
  { code:"KE", flag:"🇰🇪", name:"Kenya",         currency:"KES", operators:["M-Pesa","Airtel Money"] },
  { code:"TZ", flag:"🇹🇿", name:"Tanzanie",      currency:"TZS", operators:["M-Pesa","Tigo Pesa","Airtel Money"] },
  { code:"UG", flag:"🇺🇬", name:"Ouganda",       currency:"UGX", operators:["MTN MoMo","Airtel Money"] },
  { code:"NG", flag:"🇳🇬", name:"Nigeria",       currency:"NGN", operators:["MTN MoMo","Airtel Money","Glo Mobile"] },
  { code:"ZM", flag:"🇿🇲", name:"Zambie",        currency:"ZMW", operators:["MTN MoMo","Airtel Money","Zamtel"] },
  { code:"MW", flag:"🇲🇼", name:"Malawi",        currency:"MWK", operators:["Airtel Money","TNM Mpamba"] },
  { code:"RW", flag:"🇷🇼", name:"Rwanda",        currency:"RWF", operators:["MTN MoMo"] },
  { code:"ET", flag:"🇪🇹", name:"Éthiopie",      currency:"ETB", operators:["Telebirr"] },
  { code:"BF", flag:"🇧🇫", name:"Burkina Faso",  currency:"XOF", operators:["Orange Money","Moov Money"] },
  { code:"ML", flag:"🇲🇱", name:"Mali",          currency:"XOF", operators:["Orange Money","Moov Money"] },
  { code:"BJ", flag:"🇧🇯", name:"Bénin",         currency:"XOF", operators:["MTN MoMo","Moov Money"] },
  { code:"TG", flag:"🇹🇬", name:"Togo",          currency:"XOF", operators:["T-Money","Flooz"] },
  { code:"MZ", flag:"🇲🇿", name:"Mozambique",    currency:"MZN", operators:["M-Pesa","Airtel Money"] },
  { code:"CD", flag:"🇨🇩", name:"Congo RD",      currency:"CDF", operators:["M-Pesa","Airtel Money","Orange Money"] },
  { code:"ZW", flag:"🇿🇼", name:"Zimbabwe",      currency:"USD", operators:["EcoCash","OneMoney"] },
  { code:"ZA", flag:"🇿🇦", name:"Afrique du Sud",currency:"ZAR", operators:["MTN MoMo"] },
];
const TINGG_OPERATORS = [
  { id:"mpesa",    name:"M-Pesa",       bg:"#4CAF50", col:"#fff", codes:["KE","TZ","MZ","CD"] },
  { id:"orange",   name:"Orange Money", bg:"#FF6600", col:"#fff", codes:["CI","SN","CM","BF","ML","CD"] },
  { id:"mtn",      name:"MTN MoMo",     bg:"#FFC107", col:"#000", codes:["GH","NG","CM","CI","UG","ZM","RW","BJ"] },
  { id:"wave",     name:"Wave",         bg:"#00BCD4", col:"#fff", codes:["CI","SN","ML","BF"] },
  { id:"airtel",   name:"Airtel Money", bg:"#E53935", col:"#fff", codes:["KE","TZ","UG","ZM","MW","NG","CD"] },
  { id:"moov",     name:"Moov Money",   bg:"#1565C0", col:"#fff", codes:["CI","BJ","BF","ML","TG"] },
  { id:"telebirr", name:"Telebirr",     bg:"#4CAF50", col:"#fff", codes:["ET"] },
  { id:"ecocash",  name:"EcoCash",      bg:"#E53935", col:"#fff", codes:["ZW"] },
  { id:"tmoney",   name:"T-Money",      bg:"#7B1FA2", col:"#fff", codes:["TG"] },
  { id:"flooz",    name:"Flooz",        bg:"#F57C00", col:"#fff", codes:["TG","BJ"] },
  { id:"zamtel",   name:"Zamtel",       bg:"#2E7D32", col:"#fff", codes:["ZM"] },
  { id:"tigo",     name:"Tigo Pesa",    bg:"#1976D2", col:"#fff", codes:["TZ"] },
];
const DIAL_CODES = {
  CI:"+225",SN:"+221",CM:"+237",GH:"+233",KE:"+254",TZ:"+255",
  UG:"+256",NG:"+234",ZM:"+260",MW:"+265",RW:"+250",ET:"+251",
  BF:"+226",ML:"+223",BJ:"+229",TG:"+228",MZ:"+258",CD:"+243",ZW:"+263",ZA:"+27",
};

/* ═══════════════════════════════════════════════════════════════════════════
   Styled-components
═══════════════════════════════════════════════════════════════════════════ */
const Overlay = styled.div`position:fixed;inset:0;z-index:300;background:rgba(0,0,0,.82);backdrop-filter:blur(10px);display:flex;align-items:center;justify-content:center;padding:1rem;animation:${fadeIn} .15s ease;`;
const Modal = styled.div`background:${({theme})=>theme.bgCard};border:1px solid ${({theme})=>theme.borderLight};border-radius:18px;width:100%;max-width:460px;max-height:92vh;overflow-y:auto;animation:${slideUp} .2s ease;scrollbar-width:none;&::-webkit-scrollbar{display:none;}`;
const Head = styled.div`padding:1.25rem 1.5rem;border-bottom:1px solid ${({theme})=>theme.border};display:flex;align-items:center;justify-content:space-between;position:sticky;top:0;background:${({theme})=>theme.bgCard};z-index:2;`;
const ModalTitle = styled.h2`font-family:${({theme})=>theme.fontDisplay};font-size:1.15rem;font-weight:700;letter-spacing:-.02em;span{color:${({theme})=>theme.accent};}`;
const ModalSub = styled.p`font-size:.72rem;color:${({theme})=>theme.textMuted};margin-top:.2rem;`;
const CloseBtn = styled.button`background:none;border:none;color:${({theme})=>theme.textMuted};cursor:pointer;font-size:1.1rem;&:hover{color:${({theme})=>theme.text};}`;
const Body = styled.div`padding:1.25rem 1.5rem;display:flex;flex-direction:column;gap:1.1rem;`;
const MethodTabs = styled.div`display:grid;grid-template-columns:repeat(4,1fr);gap:.3rem;background:${({theme})=>theme.bg};border:1px solid ${({theme})=>theme.border};border-radius:10px;padding:.3rem;`;
const MethodTab = styled.button`display:flex;flex-direction:column;align-items:center;gap:.2rem;padding:.5rem .3rem;border-radius:7px;border:none;cursor:pointer;transition:all .15s;background:${({$active,theme})=>$active?theme.bgCard:"transparent"};border:1px solid ${({$active,theme})=>$active?theme.borderLight:"transparent"};box-shadow:${({$active})=>$active?"0 1px 4px rgba(0,0,0,.3)":"none"};`;
const TabIcon  = styled.span`font-size:1rem;line-height:1;`;
const TabLabel = styled.span`font-family:${({theme})=>theme.fontMono};font-size:.55rem;letter-spacing:.04em;color:${({$active,theme})=>$active?theme.text:theme.textMuted};font-weight:${({$active})=>$active?600:400};`;
const BalancePill = styled.div`display:flex;align-items:center;justify-content:space-between;background:${({theme})=>theme.bg};border:1px solid ${({theme})=>theme.border};border-radius:10px;padding:.85rem 1rem;`;
const BalLabel = styled.span`font-size:.72rem;color:${({theme})=>theme.textMuted};`;
const BalValue = styled.span`font-family:${({theme})=>theme.fontMono};font-size:1.1rem;font-weight:500;color:${({theme})=>theme.green};`;
const SectionLabel = styled.div`font-family:${({theme})=>theme.fontMono};font-size:.62rem;text-transform:uppercase;letter-spacing:.08em;color:${({theme})=>theme.textMuted};margin-bottom:.4rem;`;
const Field = styled.div`display:flex;flex-direction:column;gap:.35rem;`;
const Label = styled.label`font-size:.68rem;text-transform:uppercase;letter-spacing:.08em;color:${({theme})=>theme.textMuted};display:flex;align-items:center;gap:.4rem;`;
const Required = styled.span`color:${({theme})=>theme.red};font-size:.8rem;`;
const InputWrap = styled.div`display:flex;align-items:center;border:1px solid ${({theme,danger})=>danger?theme.red+"88":theme.border};border-radius:8px;overflow:hidden;&:focus-within{border-color:${({theme,danger})=>danger?theme.red:theme.borderLight};}`;
const Addon = styled.span`padding:.6rem .8rem;background:${({theme})=>theme.bgHover};font-family:${({theme})=>theme.fontMono};font-size:.75rem;color:${({theme})=>theme.textMuted};border-right:1px solid ${({theme})=>theme.border};white-space:nowrap;`;
const Input = styled.input`flex:1;background:transparent;border:none;outline:none;color:${({theme})=>theme.text};font-family:${({theme})=>theme.fontMono};font-size:.88rem;padding:.6rem .8rem;width:100%;&::placeholder{color:${({theme})=>theme.textMuted};}`;
const MaxBtn = styled.button`padding:.4rem .7rem;background:none;border:none;font-family:${({theme})=>theme.fontMono};font-size:.62rem;color:${({theme})=>theme.accent};cursor:pointer;&:hover{text-decoration:underline;}`;
const FieldHint = styled.span`font-size:.67rem;color:${({theme})=>theme.textMuted};`;
const CoinGrid = styled.div`display:grid;grid-template-columns:repeat(4,1fr);gap:.5rem;`;
const CoinBtn  = styled.button`display:flex;flex-direction:column;align-items:center;gap:.3rem;padding:.6rem .3rem;border-radius:10px;border:1px solid ${({$active,theme})=>$active?theme.accent+"88":theme.border};background:${({$active})=>$active?"rgba(79,195,247,.08)":"transparent"};cursor:pointer;transition:all .15s;&:hover{border-color:${({theme})=>theme.borderLight};background:${({theme})=>theme.bgHover};}`;
const CoinIcon  = styled.span`font-size:1.3rem;`;
const CoinLabel = styled.span`font-family:${({theme})=>theme.fontMono};font-size:.6rem;color:${({$active,theme})=>$active?theme.accent:theme.textDim};font-weight:${({$active})=>$active?600:400};`;
const QuickRow = styled.div`display:flex;gap:.4rem;flex-wrap:wrap;`;
const QuickBtn = styled.button`font-family:${({theme})=>theme.fontMono};font-size:.68rem;padding:.28rem .65rem;border-radius:4px;border:1px solid ${({theme})=>theme.border};background:transparent;color:${({theme})=>theme.textDim};cursor:pointer;transition:all .15s;&:hover{border-color:${({theme})=>theme.borderLight};color:${({theme})=>theme.text};}`;
const Summary = styled.div`background:${({theme})=>theme.bg};border:1px solid ${({theme})=>theme.border};border-radius:8px;padding:.85rem 1rem;display:flex;flex-direction:column;gap:.45rem;`;
const SumRow = styled.div`display:flex;justify-content:space-between;align-items:center;font-size:.78rem;`;
const SumKey = styled.span`color:${({theme})=>theme.textMuted};`;
const SumVal = styled.span`font-family:${({theme})=>theme.fontMono};color:${({$accent,theme})=>$accent?theme.accent:theme.text};font-weight:${({$accent})=>$accent?600:400};`;
const Divider = styled.div`height:1px;background:${({theme})=>theme.border};margin:.1rem 0;`;
const SubmitBtn = styled.button`width:100%;padding:.85rem;border-radius:8px;border:none;background:${({theme,disabled})=>disabled?theme.bgHover:theme.accent};color:${({theme,disabled})=>disabled?theme.textMuted:"#000"};font-family:${({theme})=>theme.fontBody};font-size:.88rem;font-weight:700;letter-spacing:.04em;cursor:${({disabled})=>disabled?"not-allowed":"pointer"};transition:opacity .15s;&:hover:not(:disabled){opacity:.9;}`;
const ErrorMsg = styled.div`font-size:.75rem;color:${({theme})=>theme.red};text-align:center;padding:.1rem 0;`;
const StatusInfo = styled.div`display:flex;align-items:flex-start;gap:.5rem;padding:.75rem 1rem;background:rgba(79,195,247,.06);border:1px solid ${({theme})=>theme.accent}33;border-radius:8px;font-size:.72rem;color:${({theme})=>theme.textDim};line-height:1.45;`;
const RewardNote  = styled.div`display:flex;align-items:flex-start;gap:.5rem;padding:.75rem 1rem;margin-bottom:1rem;background:${({theme})=>theme.bg};border:1px solid ${({theme})=>theme.border};border-radius:8px;font-size:.68rem;color:${({theme})=>theme.textMuted};line-height:1.5;`;
const PaysScroll = styled.div`display:flex;gap:.35rem;overflow-x:auto;padding-bottom:.2rem;scrollbar-width:none;&::-webkit-scrollbar{display:none;}`;
const PaysBadge  = styled.button`flex-shrink:0;padding:.25rem .7rem;border-radius:5px;cursor:pointer;font-family:${({theme})=>theme.fontMono};font-size:.62rem;letter-spacing:.04em;white-space:nowrap;transition:all .15s;border:1px solid ${({$active,theme})=>$active?theme.accent+"88":theme.border};background:${({$active})=>$active?"rgba(79,195,247,.08)":"transparent"};color:${({$active,theme})=>$active?theme.accent:theme.textMuted};`;
const PhoneRow = styled.div`display:flex;gap:.5rem;align-items:stretch;`;
const DialCode = styled.div`display:flex;align-items:center;gap:.3rem;padding:.6rem .75rem;border-radius:7px;border:1px solid ${({theme})=>theme.border};background:${({theme})=>theme.bg};font-family:${({theme})=>theme.fontMono};font-size:.8rem;color:${({theme})=>theme.textDim};white-space:nowrap;flex-shrink:0;`;
const MomoGrid = styled.div`display:grid;grid-template-columns:repeat(2,1fr);gap:.5rem;`;
const MomoBtn  = styled.button`display:flex;align-items:center;gap:.65rem;padding:.7rem .85rem;border-radius:10px;cursor:pointer;transition:all .15s;border:1px solid ${({$active,theme})=>$active?`${theme.accent}88`:theme.border};background:${({$active})=>$active?"rgba(79,195,247,.08)":"transparent"};&:hover{border-color:${({theme})=>theme.borderLight};background:${({theme})=>theme.bgHover};}`;
const MomoLogo = styled.div`width:34px;height:34px;border-radius:8px;flex-shrink:0;display:flex;align-items:center;justify-content:center;font-size:.85rem;font-weight:800;background:${({$bg})=>$bg};color:${({$col})=>$col||"#fff"};font-family:'DM Mono','Courier New',monospace;letter-spacing:-.04em;`;
const MomoName = styled.div`display:flex;flex-direction:column;gap:.05rem;text-align:left;`;
const MomoTitle2 = styled.span`font-family:${({theme})=>theme.fontMono};font-size:.72rem;font-weight:600;color:${({$active,theme})=>$active?theme.accent:theme.text};`;
const MomoPays = styled.span`font-size:.62rem;color:${({theme})=>theme.textMuted};`;
const BankCard = styled.div`background:${({theme})=>theme.bg};border:1px solid ${({theme})=>theme.border};border-radius:10px;padding:.85rem 1rem;display:flex;flex-direction:column;gap:.5rem;`;
const BankRow = styled.div`display:flex;justify-content:space-between;align-items:center;font-size:.75rem;padding:.3rem 0;border-bottom:1px solid ${({theme})=>theme.border};&:last-child{border-bottom:none;}`;
const BankKey = styled.span`color:${({theme})=>theme.textMuted};`;
const SuccessScreen = styled.div`padding:2.5rem 1.5rem;text-align:center;display:flex;flex-direction:column;align-items:center;gap:1rem;`;
const CheckCircle = styled.div`width:64px;height:64px;border-radius:50%;background:rgba(0,230,118,.12);border:2px solid ${({theme})=>theme.green};display:flex;align-items:center;justify-content:center;font-size:1.8rem;animation:${checkIn} .4s cubic-bezier(.4,0,.2,1) both;`;
const SuccessTitle = styled.h3`font-family:${({theme})=>theme.fontDisplay};font-size:1.2rem;font-weight:700;color:${({theme})=>theme.text};`;
const SuccessSub = styled.p`font-size:.78rem;color:${({theme})=>theme.textMuted};max-width:280px;line-height:1.5;`;
const SuccessRef = styled.div`font-family:${({theme})=>theme.fontMono};font-size:.7rem;color:${({theme})=>theme.textDim};padding:.4rem .9rem;background:${({theme})=>theme.bgHover};border-radius:6px;border:1px solid ${({theme})=>theme.border};span{color:${({theme})=>theme.accent};}`;
const DoneBtn = styled.button`padding:.6rem 1.6rem;border-radius:8px;border:1px solid ${({theme})=>theme.borderLight};background:transparent;color:${({theme})=>theme.text};font-family:${({theme})=>theme.fontBody};font-size:.78rem;font-weight:600;cursor:pointer;transition:all .15s;&:hover{background:${({theme})=>theme.bgHover};}`;

/* ═══════════════════════════════════════════════════════════════════════════
   SHARED ELIGIBILITY BANNER (utilisé par Mobile, Bank, PayPal)
═══════════════════════════════════════════════════════════════════════════ */
function EligibilityBanner({ eligibility, eligLoading, t }) {
  if (eligLoading) {
    return (
      <div style={{padding:".75rem 1rem",background:"rgba(79,195,247,.05)",
        border:"1px solid rgba(79,195,247,.2)",borderRadius:"8px",fontSize:".75rem",color:"#8a9aaa"}}>
        {t("elig.loading")}
      </div>
    );
  }
  if (!eligibility) {
    return (
      <div style={{padding:".75rem 1rem",background:"rgba(255,59,92,.06)",
        border:"1px solid rgba(255,59,92,.2)",borderRadius:"8px",fontSize:".75rem",color:"#ff3b5c"}}>
        ⚠ {t("elig.err")}
      </div>
    );
  }
  if (eligibility.eligible) {
    return (
      <div style={{padding:".85rem 1rem",background:"rgba(0,230,118,.06)",
        border:"1px solid rgba(0,230,118,.25)",borderRadius:"8px"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"baseline",marginBottom:".4rem"}}>
          <span style={{fontSize:".7rem",color:"#00e676",textTransform:"uppercase",
            letterSpacing:".05em",fontFamily:"DM Mono,monospace"}}>
            ✓ {t("elig.ok")}
          </span>
          <span style={{fontSize:".68rem",color:"#5a6a7a",fontFamily:"DM Mono,monospace"}}>
            {t("elig.rate")}
          </span>
        </div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"baseline"}}>
          <span style={{fontSize:".78rem",color:"#8a9aaa"}}>{t("elig.withdrawable")} :</span>
          <span style={{fontSize:"1.05rem",fontWeight:700,color:"#00e676",fontFamily:"DM Mono,monospace"}}>
            ${eligibility.withdrawable_usd}
            <span style={{fontSize:".7rem",fontWeight:400,color:"#5a6a7a",marginLeft:".3rem"}}>
              ({eligibility.withdrawable_evp} EVP)
            </span>
          </span>
        </div>
      </div>
    );
  }
  return (
    <div style={{padding:".85rem 1rem",background:"rgba(255,193,7,.06)",
      border:"1px solid rgba(255,193,7,.25)",borderRadius:"8px"}}>
      <div style={{fontSize:".75rem",color:"#ffc107",fontWeight:600,marginBottom:".5rem",
        fontFamily:"DM Mono,monospace",letterSpacing:".05em"}}>
        ⚠ {t("elig.notok")}
      </div>
      <div style={{display:"flex",flexDirection:"column",gap:".35rem",marginBottom:".7rem"}}>
        {eligibility.reasons_blocked.map((r, i) => (
          <div key={i} style={{fontSize:".72rem",color:"#e8edf2",lineHeight:1.45}}>• {r}</div>
        ))}
      </div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:".5rem",
        fontSize:".68rem",fontFamily:"DM Mono,monospace",color:"#5a6a7a"}}>
        <div>{t("elig.trades")} : <strong style={{color:eligibility.checks.trades_count.passed?"#00e676":"#ff3b5c"}}>
          {eligibility.checks.trades_count.value}/{eligibility.checks.trades_count.required}
        </strong></div>
        <div>{t("elig.days")} : <strong style={{color:eligibility.checks.active_days.passed?"#00e676":"#ff3b5c"}}>
          {eligibility.checks.active_days.value}/{eligibility.checks.active_days.required}
        </strong></div>
        <div>{t("elig.retirable")} : <strong style={{color:eligibility.checks.balance.passed?"#00e676":"#ff3b5c"}}>
          ${eligibility.withdrawable_usd}
        </strong></div>
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════════════════════
   MAIN COMPONENT
═══════════════════════════════════════════════════════════════════════════ */
export default function WithdrawModal({ balance = 1000, onClose, onSuccess }) {
  const { lang } = useI18n();
  const t = (key, vars) => wt(key, lang, vars);

  const [method,  setMethod]  = useState("mobile");
  const [success, setSuccess] = useState(null);
  const [error,   setError]   = useState(null);
  const [loading, setLoading] = useState(false);

  // ── Eligibility ──
  const [eligibility, setEligibility] = useState(null);
  const [eligLoading, setEligLoading] = useState(true);

  useEffect(() => {
    getWithdrawalEligibility()
      .then(r => setEligibility(r.data))
      .catch(() => setEligibility(null))
      .finally(() => setEligLoading(false));
  }, []);

  // ── Crypto state ──
  const [coin,    setCoin]    = useState("EVP");
  const [amount,  setAmount]  = useState("");
  const [address, setAddress] = useState("");

  // ── Mobile state ──
  const [mobPays,    setMobPays]    = useState(null);
  const [mobSelOp,   setMobSelOp]   = useState(null);
  const [mobPhone,   setMobPhone]   = useState("");
  const [mobAmount,  setMobAmount]  = useState("");

  // ── Bank state ──
  const [bankIban,   setBankIban]   = useState("");
  const [bankBic,    setBankBic]    = useState("");
  const [bankName,   setBankName]   = useState("");
  const [bankAmount, setBankAmount] = useState("");

  // ── PayPal state ──
  const [ppEmail,    setPpEmail]    = useState("");
  const [ppAmount,   setPpAmount]   = useState("");

  /* ── Crypto calcs ── */
  const coinCfg     = COINS.find(c => c.id === coin);
  const amtNum      = parseFloat(amount) || 0;
  const networkFee  = coinCfg.fee;
  const platformFee = parseFloat((amtNum * FEE_RATE).toFixed(4));
  const youGet      = Math.max(0, amtNum - platformFee - networkFee).toFixed(4);
  const canCrypto   = amtNum >= 5 && amtNum <= balance && address.length > 10;

  /* ── Manual methods : valeurs partagées ── */
  const withdrawableUsd = parseFloat(eligibility?.withdrawable_usd || 0);
  const minMobile       = parseFloat(eligibility?.method_minimums?.mobile || 1);
  const minBank         = parseFloat(eligibility?.method_minimums?.bank   || 5);
  const minPaypal       = parseFloat(eligibility?.method_minimums?.paypal || 1);

  /* ── Mobile calcs ── */
  const mobCountry  = TINGG_COUNTRIES.find(c => c.code === mobPays);
  const mobDialCode = DIAL_CODES[mobPays] || "+XX";
  const mobAmtNum   = parseFloat(mobAmount) || 0;
  const mobAmtEvp   = mobAmtNum * 100;
  const canMobile   =
    eligibility?.eligible &&
    mobPays && mobPhone.length >= 6 &&
    mobAmtNum >= minMobile && mobAmtNum <= withdrawableUsd;

  /* ── Bank calcs ── */
  const bankAmtNum = parseFloat(bankAmount) || 0;
  const bankAmtEvp = bankAmtNum * 100;
  const canBank    =
    eligibility?.eligible &&
    bankIban.replace(/\s/g,"").length >= 15 &&
    bankBic.length >= 8 && bankBic.length <= 11 &&
    bankName.trim().length >= 2 &&
    bankAmtNum >= minBank && bankAmtNum <= withdrawableUsd;

  /* ── PayPal calcs ── */
  const ppAmtNum  = parseFloat(ppAmount) || 0;
  const ppAmtEvp  = ppAmtNum * 100;
  const emailRe   = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
  const canPaypal =
    eligibility?.eligible &&
    emailRe.test(ppEmail.trim()) &&
    ppAmtNum >= minPaypal && ppAmtNum <= withdrawableUsd;

  /* ── Visible operators ── */
  const visibleOps = mobPays
    ? TINGG_OPERATORS.filter(o => o.codes.includes(mobPays))
    : TINGG_OPERATORS;

  const handleSelectOp = (op) => {
    setMobSelOp(op);
    if (!mobPays && op.codes.length > 0) setMobPays(op.codes[0]);
  };

  /* ── Submit handlers ── */

  const handleCryptoSubmit = async () => {
    if (!canCrypto) return;
    setLoading(true); setError(null);
    try {
      const res = await requestWithdrawal({ coin, amount: amtNum, address });
      setSuccess({ method:"crypto", id: res.data?.id || `WDR-${Date.now().toString(36).toUpperCase()}`, amount: amtNum, coin });
    } catch {
      setSuccess({ method:"crypto", id:`WDR-${Date.now().toString(36).toUpperCase()}`, amount:amtNum, coin });
    } finally { setLoading(false); }
  };

  const submitPayout = async (payload, onOk) => {
    setLoading(true); setError(null);
    try {
      const res = await createPayoutRequest(payload);
      onOk(res.data);
      onSuccess?.();
    } catch (e) {
      const msg = e?.response?.data?.detail || "Erreur lors de la création du retrait.";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  const handleMobileSubmit = () => {
    if (!canMobile) return;
    submitPayout({
      method:   "mobile",
      amount:   mobAmtNum,
      currency: mobCountry?.currency || "USD",
      details:  {
        phone:        mobDialCode.replace("+","") + mobPhone.replace(/^0/,""),
        country_code: mobPays,
      },
    }, (data) => setSuccess({
      method:"mobile", id:data.id, amount:mobAmtNum, phone:mobPhone, pays:mobPays,
    }));
  };

  const handleBankSubmit = () => {
    if (!canBank) return;
    submitPayout({
      method:   "bank",
      amount:   bankAmtNum,
      currency: "USD",
      details:  {
        iban:         bankIban.replace(/\s/g,""),
        bic:          bankBic,
        account_name: bankName.trim(),
      },
    }, (data) => setSuccess({
      method:"bank", id:data.id, amount:bankAmtNum,
    }));
  };

  const handlePaypalSubmit = () => {
    if (!canPaypal) return;
    submitPayout({
      method:   "paypal",
      amount:   ppAmtNum,
      currency: "USD",
      details:  { email: ppEmail.trim().toLowerCase() },
    }, (data) => setSuccess({
      method:"paypal", id:data.id, amount:ppAmtNum, email:ppEmail.trim(),
    }));
  };

  /* ═══ Success screen ═══ */
  if (success) {
    const titleMap = { crypto:"succ.title_c", mobile:"succ.title_m", bank:"succ.title_b", paypal:"succ.title_p" };
    const msg =
      success.method === "crypto" ? t("succ.msg_c", { amount: success.amount, coin: success.coin })
    : success.method === "mobile" ? t("succ.msg_m", { amount: success.amount, dial: mobDialCode, phone: success.phone })
    : success.method === "bank"   ? t("succ.msg_b", { amount: success.amount })
    :                                t("succ.msg_p", { amount: success.amount, email: success.email });

    return (
      <Overlay onClick={e => e.target === e.currentTarget && onClose()}>
        <Modal>
          <SuccessScreen>
            <CheckCircle>✓</CheckCircle>
            <SuccessTitle>{t(titleMap[success.method])}</SuccessTitle>
            <SuccessSub>{msg}</SuccessSub>
            <SuccessRef>{t("succ.ref")} : <span>{success.id}</span></SuccessRef>
            <DoneBtn onClick={onClose}>{t("btn.close")}</DoneBtn>
          </SuccessScreen>
        </Modal>
      </Overlay>
    );
  }

  return (
    <Overlay onClick={e => e.target === e.currentTarget && onClose()}>
      <Modal>
        <Head>
          <div>
            <ModalTitle>{t("title")} <span>{t("title2")}</span></ModalTitle>
            <ModalSub>{t("sub")}</ModalSub>
          </div>
          <CloseBtn onClick={onClose}>✕</CloseBtn>
        </Head>

        <Body>
          <RewardNote>
            <span>🎁</span>
            <span>{t("reward.desc")}</span>
          </RewardNote>

          {/* Balance */}
          <BalancePill>
            <BalLabel>{t("bal")}</BalLabel>
            <BalValue>{balance.toLocaleString("en-US",{minimumFractionDigits:2})} EVP</BalValue>
          </BalancePill>

          {/* Method tabs (4) */}
          <MethodTabs>
            {[
           //   {id:"crypto", icon:"₿",  k:"tab.crypto"},
              {id:"mobile", icon:"📱", k:"tab.mobile"},
              {id:"bank",   icon:"🏦", k:"tab.bank"},
              {id:"paypal", icon:"🅿️", k:"tab.paypal"},
            ].map(m=>(
              <MethodTab key={m.id} $active={method===m.id} onClick={()=>{setMethod(m.id);setError(null);}}>
                <TabIcon>{m.icon}</TabIcon>
                <TabLabel $active={method===m.id}>{t(m.k)}</TabLabel>
              </MethodTab>
            ))}
          </MethodTabs>

          {/* ══════ CRYPTO ══════ */}
          {false && method==="crypto" && <>
            <Field>
              <Label>{t("lbl.receive")} <Required>*</Required></Label>
              <CoinGrid>
                {COINS.map(c=>(
                  <CoinBtn key={c.id} $active={coin===c.id} onClick={()=>setCoin(c.id)}>
                    <CoinIcon>{c.icon}</CoinIcon>
                    <CoinLabel $active={coin===c.id}>{c.label}</CoinLabel>
                  </CoinBtn>
                ))}
              </CoinGrid>
            </Field>

            <Field>
              <Label>{t("lbl.amount")} <Required>*</Required></Label>
              <InputWrap danger={amtNum > balance ? 1 : 0}>
                <Addon>EVP</Addon>
                <Input type="number" min="5" step="1" max={balance}
                  placeholder={t("ph.amount")} value={amount}
                  onChange={e=>setAmount(e.target.value)}/>
                <MaxBtn onClick={()=>setAmount(String(balance))}>MAX</MaxBtn>
              </InputWrap>
              <QuickRow>
                {[50,100,250,500].map(n=>(
                  <QuickBtn key={n} onClick={()=>setAmount(String(Math.min(n,balance)))}>{n} EVP</QuickBtn>
                ))}
              </QuickRow>
              {amtNum > balance && <FieldHint style={{color:"#ff3b5c"}}>{t("hint.insufficient")}</FieldHint>}
              {amtNum > 0 && amtNum < 5 && <FieldHint style={{color:"#ffc107"}}>{t("hint.min_crypto")}</FieldHint>}
            </Field>

            <Field>
              <Label>{t("lbl.address")} <Required>*</Required></Label>
              <InputWrap>
                <Input placeholder={coin==="BTC"?"bc1q…":"0x…"}
                  value={address} onChange={e=>setAddress(e.target.value)}/>
              </InputWrap>
              <FieldHint>{t("hint.address", {coin})}</FieldHint>
            </Field>

            {amtNum > 0 && (
              <Summary>
                <SumRow><SumKey>{t("sum.send")}</SumKey><SumVal>${amtNum.toFixed(2)} EVP</SumVal></SumRow>
                <SumRow><SumKey>{t("sum.fee_plat")}</SumKey><SumVal>− ${platformFee} EVP</SumVal></SumRow>
                <SumRow><SumKey>{t("sum.fee_net")}</SumKey><SumVal>− {networkFee} {coin}</SumVal></SumRow>
                <Divider/>
                <SumRow>
                  <SumKey>{t("sum.receive")}</SumKey>
                  <SumVal $accent>{parseFloat(youGet)>0?youGet:"0.0000"} {coin}</SumVal>
                </SumRow>
              </Summary>
            )}

            <StatusInfo>
              <span>🔍</span>
              <span>{t("info.crypto")} <strong style={{color:"#e8edf2"}}>{t("delay_crypto")}</strong>.</span>
            </StatusInfo>

            {error && <ErrorMsg>{error}</ErrorMsg>}
            <SubmitBtn disabled={!canCrypto||loading} onClick={handleCryptoSubmit}>
              {loading ? t("btn.sending") : `${t("btn.withdraw")} ${amtNum>0?`$${amtNum.toFixed(2)}`:""}`.trim()}
            </SubmitBtn>
          </>}

          {/* ══════ MOBILE ══════ */}
          {method==="mobile" && <>
            <EligibilityBanner eligibility={eligibility} eligLoading={eligLoading} t={t}/>

            {eligibility?.eligible && <>
              <div>
                <SectionLabel>
                  {t("lbl.country")}
                  {mobPays && mobCountry && (
                    <span style={{marginLeft:".5rem",color:"#4fc3f7",fontWeight:400,
                      textTransform:"none",letterSpacing:0}}>
                      — {visibleOps.length} {visibleOps.length>1?t("operators"):t("operator")}
                    </span>
                  )}
                </SectionLabel>
                <PaysScroll>
                  <PaysBadge $active={!mobPays} onClick={()=>{setMobPays(null);setMobPhone("");setMobSelOp(null);}}>
                    🌍 {t("all")}
                  </PaysBadge>
                  {TINGG_COUNTRIES.map(c=>(
                    <PaysBadge key={c.code} $active={mobPays===c.code}
                      onClick={()=>{setMobPays(c.code);setMobPhone("");setMobSelOp(null);}}>
                      {c.flag} {c.name}
                    </PaysBadge>
                  ))}
                </PaysScroll>
              </div>

              <div>
                <SectionLabel>{mobPays ? t("lbl.operators") : t("lbl.operator")}</SectionLabel>
                {!mobPays ? (
                  <MomoGrid>
                    {visibleOps.map(op=>(
                      <MomoBtn key={op.id} $active={mobSelOp?.id===op.id} onClick={()=>handleSelectOp(op)}>
                        <MomoLogo $bg={op.bg} $col={op.col}>{op.name.slice(0,2)}</MomoLogo>
                        <MomoName>
                          <MomoTitle2 $active={mobSelOp?.id===op.id}>{op.name}</MomoTitle2>
                          <MomoPays>
                            {op.codes.slice(0,3).map(c=>{
                              const ct = TINGG_COUNTRIES.find(t=>t.code===c);
                              return ct?ct.flag:c;
                            }).join(" ")}
                            {op.codes.length>3&&` +${op.codes.length-3}`}
                          </MomoPays>
                        </MomoName>
                      </MomoBtn>
                    ))}
                  </MomoGrid>
                ) : (
                  <div style={{display:"flex",flexWrap:"wrap",gap:".35rem"}}>
                    {mobCountry?.operators.map(name=>{
                      const op = TINGG_OPERATORS.find(o=>name.includes(o.name.split(" ")[0]));
                      return (
                        <div key={name} style={{display:"flex",alignItems:"center",gap:".5rem",
                          padding:".4rem .8rem",borderRadius:"8px",
                          border:"1px solid #1e2530",background:"#080a0c"}}>
                          {op && <div style={{width:20,height:20,borderRadius:"5px",flexShrink:0,
                            background:op.bg,display:"flex",alignItems:"center",justifyContent:"center",
                            fontSize:".55rem",fontWeight:800,color:op.col||"#fff",
                            fontFamily:"DM Mono,monospace"}}>{op.name.slice(0,2)}</div>}
                          <span style={{fontSize:".72rem",color:"#8a9aaa"}}>{name}</span>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>

              <Field>
                <Label>{t("lbl.amount_w")} <Required>*</Required></Label>
                <InputWrap danger={mobAmtNum > withdrawableUsd ? 1 : 0}>
                  <Addon>USD</Addon>
                  <Input type="number" min={minMobile} step="0.5"
                    placeholder={t("ph.amount")} value={mobAmount}
                    onChange={e=>setMobAmount(e.target.value)}/>
                  <MaxBtn onClick={()=>setMobAmount(String(withdrawableUsd))}>MAX</MaxBtn>
                </InputWrap>
                <QuickRow>
                  {[1,5,10,25,50].map(n=>(
                    <QuickBtn key={n} onClick={()=>setMobAmount(String(Math.min(n,withdrawableUsd)))}>{n} EVP</QuickBtn>
                  ))}
                </QuickRow>
                {mobAmtNum > withdrawableUsd && <FieldHint style={{color:"#ff3b5c"}}>{t("hint.insufficient")}</FieldHint>}
                {mobAmtNum > 0 && mobAmtNum < minMobile && (
                  <FieldHint style={{color:"#ffc107"}}>{t("hint.min", {min: minMobile})}</FieldHint>
                )}
                {mobAmtNum >= minMobile && (
                  <FieldHint style={{color:"#5a6a7a"}}>{t("hint.evp_eq", {evp: mobAmtEvp.toFixed(0)})}</FieldHint>
                )}
              </Field>

              <Field>
                <Label>{t("lbl.phone")} <Required>*</Required></Label>
                <PhoneRow>
                  <DialCode>{mobDialCode}</DialCode>
                  <InputWrap style={{flex:1,borderRadius:"8px"}}>
                    <Input type="tel" placeholder={t("ph.phone")}
                      value={mobPhone}
                      onChange={e=>setMobPhone(e.target.value.replace(/\D/g,"").slice(0,12))}/>
                  </InputWrap>
                </PhoneRow>
              </Field>

              {mobPays && mobAmtNum >= minMobile && (
                <Summary>
                  <SumRow><SumKey>{t("sum.withdraw")}</SumKey><SumVal>${mobAmtNum.toFixed(2)} USD</SumVal></SumRow>
                  <SumRow><SumKey>{mobAmtEvp.toFixed(0)} EVP</SumKey><SumVal style={{color:"#5a6a7a"}}>débités</SumVal></SumRow>
                  <SumRow><SumKey>{t("sum.fee_payout")}</SumKey><SumVal style={{color:"#00e676"}}>{t("sum.free")}</SumVal></SumRow>
                  <SumRow><SumKey>{t("sum.delay")}</SumKey><SumVal>{t("sum.delay_mob")}</SumVal></SumRow>
                  <Divider/>
                  <SumRow>
                    <SumKey>{t("sum.receive_e")}</SumKey>
                    <SumVal $accent>${mobAmtNum.toFixed(2)} en {mobCountry?.currency}</SumVal>
                  </SumRow>
                </Summary>
              )}

              <StatusInfo>
                <span>⏱</span>
                <span>{t("info.mobile")}</span>
              </StatusInfo>

              {error && <ErrorMsg>{error}</ErrorMsg>}
              <SubmitBtn disabled={!canMobile||loading} onClick={handleMobileSubmit}>
                {loading ? t("btn.sending_l")
                  : mobPays ? t("btn.via_mob", {country: mobCountry?.name})
                  : t("btn.select_c")}
              </SubmitBtn>
            </>}
          </>}

          {/* ══════ BANK ══════ */}
          {method==="bank" && <>
            <EligibilityBanner eligibility={eligibility} eligLoading={eligLoading} t={t}/>

            {eligibility?.eligible && <>
              <Field>
                <Label>{t("lbl.amount_w")} <Required>*</Required></Label>
                <InputWrap danger={bankAmtNum > withdrawableUsd ? 1 : 0}>
                  <Addon>USD</Addon>
                  <Input type="number" min={minBank} step="0.5" placeholder={t("ph.amount")}
                    value={bankAmount} onChange={e=>setBankAmount(e.target.value)}/>
                  <MaxBtn onClick={()=>setBankAmount(String(withdrawableUsd))}>MAX</MaxBtn>
                </InputWrap>
                <QuickRow>
                  {[5,10,25,50,100].map(n=>(
                    <QuickBtn key={n} onClick={()=>setBankAmount(String(Math.min(n,withdrawableUsd)))}>{n} EVP</QuickBtn>
                  ))}
                </QuickRow>
                {bankAmtNum > withdrawableUsd && <FieldHint style={{color:"#ff3b5c"}}>{t("hint.insufficient")}</FieldHint>}
                {bankAmtNum > 0 && bankAmtNum < minBank && (
                  <FieldHint style={{color:"#ffc107"}}>{t("hint.min", {min: minBank})}</FieldHint>
                )}
                {bankAmtNum >= minBank && (
                  <FieldHint style={{color:"#5a6a7a"}}>{t("hint.evp_eq", {evp: bankAmtEvp.toFixed(0)})}</FieldHint>
                )}
              </Field>

              <div>
                <SectionLabel>{t("lbl.bank")}</SectionLabel>
                <BankCard>
                  <BankRow><BankKey>{t("lbl.holder")}</BankKey></BankRow>
                  <InputWrap style={{borderRadius:"8px",border:"1px solid #1e2530"}}>
                    <Input placeholder={t("ph.holder")}
                      value={bankName} onChange={e=>setBankName(e.target.value)}/>
                  </InputWrap>
                  <BankRow style={{marginTop:".5rem"}}><BankKey>{t("lbl.iban")}</BankKey></BankRow>
                  <InputWrap style={{borderRadius:"8px",border:"1px solid #1e2530"}}>
                    <Input placeholder="FR76 3000 4000 0300 0000 3456 789"
                      value={bankIban}
                      onChange={e=>setBankIban(e.target.value.toUpperCase())}/>
                  </InputWrap>
                  <BankRow style={{marginTop:".5rem"}}><BankKey>{t("lbl.bic")}</BankKey></BankRow>
                  <InputWrap style={{borderRadius:"8px",border:"1px solid #1e2530"}}>
                    <Input placeholder="BNPAFRPPXXX"
                      value={bankBic}
                      onChange={e=>setBankBic(e.target.value.toUpperCase())}/>
                  </InputWrap>
                </BankCard>
              </div>

              {bankAmtNum >= minBank && (
                <Summary>
                  <SumRow><SumKey>{t("sum.withdraw")}</SumKey><SumVal>${bankAmtNum.toFixed(2)} USD</SumVal></SumRow>
                  <SumRow><SumKey>{bankAmtEvp.toFixed(0)} EVP</SumKey><SumVal style={{color:"#5a6a7a"}}>débités</SumVal></SumRow>
                  <SumRow><SumKey>{t("sum.fee_payout")}</SumKey><SumVal style={{color:"#00e676"}}>{t("sum.free")}</SumVal></SumRow>
                  <SumRow><SumKey>{t("sum.delay")}</SumKey><SumVal>{t("sum.delay_bank")}</SumVal></SumRow>
                  <Divider/>
                  <SumRow>
                    <SumKey>{t("sum.receive_e")}</SumKey>
                    <SumVal $accent>${bankAmtNum.toFixed(2)}</SumVal>
                  </SumRow>
                </Summary>
              )}

              <StatusInfo>
                <span>🏦</span>
                <span>{t("info.bank")}</span>
              </StatusInfo>

              {error && <ErrorMsg>{error}</ErrorMsg>}
              <SubmitBtn disabled={!canBank||loading} onClick={handleBankSubmit}>
                {loading ? t("btn.sending_l")
                  : `${t("btn.bank")} ${bankAmtNum>=minBank?`$${bankAmtNum.toFixed(2)}`:""}`.trim()}
              </SubmitBtn>
            </>}
          </>}

          {/* ══════ PAYPAL ══════ */}
          {method==="paypal" && <>
            <EligibilityBanner eligibility={eligibility} eligLoading={eligLoading} t={t}/>

            {eligibility?.eligible && <>
              <Field>
                <Label>{t("lbl.email_pp")} <Required>*</Required></Label>
                <InputWrap>
                  <Input type="email" placeholder={t("ph.email")}
                    value={ppEmail}
                    onChange={e=>setPpEmail(e.target.value)}/>
                </InputWrap>
                <FieldHint>{t("hint.paypal")}</FieldHint>
              </Field>

              <Field>
                <Label>{t("lbl.amount_w")} <Required>*</Required></Label>
                <InputWrap danger={ppAmtNum > withdrawableUsd ? 1 : 0}>
                  <Addon>USD</Addon>
                  <Input type="number" min={minPaypal} step="0.5" placeholder={t("ph.amount")}
                    value={ppAmount} onChange={e=>setPpAmount(e.target.value)}/>
                  <MaxBtn onClick={()=>setPpAmount(String(withdrawableUsd))}>MAX</MaxBtn>
                </InputWrap>
                <QuickRow>
                  {[1,5,10,25,50].map(n=>(
                    <QuickBtn key={n} onClick={()=>setPpAmount(String(Math.min(n,withdrawableUsd)))}>{n} EVP</QuickBtn>
                  ))}
                </QuickRow>
                {ppAmtNum > withdrawableUsd && <FieldHint style={{color:"#ff3b5c"}}>{t("hint.insufficient")}</FieldHint>}
                {ppAmtNum > 0 && ppAmtNum < minPaypal && (
                  <FieldHint style={{color:"#ffc107"}}>{t("hint.min", {min: minPaypal})}</FieldHint>
                )}
                {ppAmtNum >= minPaypal && (
                  <FieldHint style={{color:"#5a6a7a"}}>{t("hint.evp_eq", {evp: ppAmtEvp.toFixed(0)})}</FieldHint>
                )}
              </Field>

              {/* PayPal badge */}
              <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",
                padding:".5rem .75rem",borderRadius:"8px",background:"#080a0c",border:"1px solid #1e2530"}}>
                <div style={{display:"flex",alignItems:"center",gap:".5rem"}}>
                  <div style={{width:28,height:28,borderRadius:"6px",background:"#003087",
                    display:"flex",alignItems:"center",justifyContent:"center",
                    fontFamily:"DM Mono,monospace",fontSize:".7rem",fontWeight:800,color:"#fff"}}>P</div>
                  <div>
                    <div style={{fontSize:".7rem",fontWeight:600,color:"#e8edf2"}}>PayPal</div>
                    <div style={{fontSize:".6rem",color:"#5a6a7a"}}>200+ pays · 25 devises</div>
                  </div>
                </div>
                <a href="https://paypal.com" target="_blank" rel="noreferrer"
                  style={{fontSize:".62rem",color:"#4fc3f7",textDecoration:"none"}}>paypal.com ↗</a>
              </div>

              {ppAmtNum >= minPaypal && emailRe.test(ppEmail.trim()) && (
                <Summary>
                  <SumRow><SumKey>{t("sum.withdraw")}</SumKey><SumVal>${ppAmtNum.toFixed(2)} USD</SumVal></SumRow>
                  <SumRow><SumKey>{ppAmtEvp.toFixed(0)} EVP</SumKey><SumVal style={{color:"#5a6a7a"}}>débités</SumVal></SumRow>
                  <SumRow><SumKey>{t("sum.fee_payout")}</SumKey><SumVal style={{color:"#00e676"}}>{t("sum.free")}</SumVal></SumRow>
                  <SumRow><SumKey>{t("sum.delay")}</SumKey><SumVal>{t("sum.delay_pp")}</SumVal></SumRow>
                  <Divider/>
                  <SumRow>
                    <SumKey>{t("sum.receive_e")}</SumKey>
                    <SumVal $accent>${ppAmtNum.toFixed(2)}</SumVal>
                  </SumRow>
                </Summary>
              )}

              <StatusInfo>
                <span>🅿️</span>
                <span>{t("info.paypal")}</span>
              </StatusInfo>

              {error && <ErrorMsg>{error}</ErrorMsg>}
              <SubmitBtn disabled={!canPaypal||loading} onClick={handlePaypalSubmit}>
                {loading ? t("btn.sending_l")
                  : `${t("btn.paypal")} ${ppAmtNum>=minPaypal?`${ppAmtNum.toFixed(2)} EVP`:""}`.trim()}
              </SubmitBtn>
            </>}
          </>}
        </Body>
      </Modal>
    </Overlay>
  );
}
